import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export function tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.vars.palette.grey[800],
          '[data-mui-color-scheme="dark"] &': {
            backgroundColor: theme.vars.palette.grey[700],
          },
        },
        arrow: {
          color: theme.vars.palette.grey[800],
          '[data-mui-color-scheme="dark"] &': {
            color: theme.vars.palette.grey[700],
          },
        },
      },
    },
  }
}
